import UtilityService from "../services/UtillityServices/UtilityService";

export default function useGestioneContabilizzazioniConfigTable() {
    return [
      { 
        label: "Corso", 
        key: "corso",
        hideOrder: true,
        formatter: (value, row) => {
          let text = `${row.denominazione_corso}`;
          
          if (row.data_inizio && row.data_fine) {
            text += ` (${UtilityService.formatDate(row.data_inizio)} - ${UtilityService.formatDate(row.data_fine)})`;
          }
          
          return text;
        }
      },
      {
        label: "Stato pagamento corso",
        key: "stato_pagamento",
        hideOrder: true,
        formatter: (value, row) => `${row.stato_pagamento.replace(/_/g, ' ')?.toUpperCase()}`
      },
      { 
        label: "Corsista", 
        key: "corsista",
        hideOrder: true,
        formatter: (value, row) => `${row.corsista.nome} ${row.corsista.cognome}`
      },
      { 
        label: "Partner", 
        key: "partner",
        hideOrder: true,
        formatter: (value, row) => `${row.partner.nome} ${row.partner.cognome} (${row.partner.agenzia.denominazione})`
      },
      { 
        label: "Data", 
        key: "data_inserimento",
        formatter: (value, row) => `${UtilityService.formatDate(row.data_inserimento)}`
      },
      { 
        label: "Sconto", 
        key: "sconto",
        hideOrder: true,
        formatter: (value, row) => `${row.sconto} €`
      },
      { 
        label: "Provvigione Partner", 
        key: "provvigione_partner",
        hideOrder: true,
        formatter: (value, row) => `${row.provvigione_partner} €`
      },
      { 
        label: "Stato", 
        key: "stato_contabilizzazione",
        hideOrder: true,
        formatter: (value, row) => `${row.stato_contabilizzazione.replace(/_/g, ' ')?.toUpperCase()}`
      },
    ];
  }
  